import React, { useState } from "react";

interface SkillsProps {
  skills: string[];
  topMargin?: boolean;
  smallText?: boolean;
}

const SkillsList: React.FC<SkillsProps> = ({ skills, topMargin = true, smallText = false }) => {
  const [showAll, setShowAll] = useState(false);

  // Limit the number of skills displayed initially
  const displayedSkills = showAll ? skills : skills.slice(0, 4);

  // Handle click event to show all skills
  const handleShowMore = () => {
    setShowAll(true);
  };

  return (
    <ul className={`gap-1 flex items-center flex-wrap ${topMargin ? "mt-5" : ""}`}>
      <li>
        <p className={`text-text-quaternary font-semibold ${smallText ? "text-xs" : "text-sm"}`}>
          Skills:
        </p>
      </li>
      {displayedSkills.map((skill, index) => (
        <li
          key={index}
          className={`px-2.5 py-0.5 text-[#026AA2] ${
            smallText ? "text-xs" : "text-sm"
          } font-medium bg-[#F0F9FF] rounded-full cursor-pointer`}
        >
          {skill}
        </li>
      ))}
      {!showAll && skills.length > 4 && (
        <li
          onClick={handleShowMore}
          className={`px-2.5 py-0.5 text-[#026AA2] ${
            smallText ? "text-xs" : "text-sm"
          } font-medium bg-[#F0F9FF] rounded-full cursor-pointer`}
        >
          +{skills.length - 4}
        </li>
      )}
    </ul>
  );
};

export default SkillsList;
